import { useEffect, useState } from 'react';
import { useUtilisateurService } from '@europrocurement/l2d-domain';
import {
    type GroupesDeTravailJsonldUserworkgroupRead,
    type UtilisateursJsonldUserworkgroupRead,
} from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';
import { useSnackbar } from 'notistack';

// Return all users of all groups of a formalist
const useUsersInGroups = (
    formalistId: number | undefined,
): UtilisateursJsonldUserworkgroupRead[] => {
    const { utilisateursGroupeTravailApi } = useUtilisateurService();
    const { enqueueSnackbar } = useSnackbar();

    const [userGroups, setUserGroups] = useState<GroupesDeTravailJsonldUserworkgroupRead[]>([]);
    const [usersInGroups, setUsersInGroups] = useState<UtilisateursJsonldUserworkgroupRead[]>([]);

    useEffect(() => {
        if (!formalistId) return;

        utilisateursGroupeTravailApi
            .apiUtilisateurgroupetravailGetCollection({ user2: [formalistId.toString()] })
            .then((res) => {
                setUserGroups(
                    res.data['hydra:member']
                        .filter((ug) => ug.groupetravail && !ug.groupetravail.fDelete)
                        .map((ug) => ug.groupetravail!),
                );
            })
            .catch((err) => {
                console.error(err);
                enqueueSnackbar('Une erreur est survenue lors de la récupération de vos groupes', {
                    variant: 'error',
                });
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formalistId]);

    useEffect(() => {
        if (userGroups.length === 0) return;

        utilisateursGroupeTravailApi
            .apiUtilisateurgroupetravailGetCollection({
                groupetravail2: userGroups.map((g) => g['@id'] as string),
            })
            .then((res) => {
                const seen = new Set<number>();
                setUsersInGroups(
                    res.data['hydra:member']
                        .map((ug) => ug.user!)
                        .filter((user) => {
                            if (!user.isFormalist || seen.has(user.id!)) return false;
                            seen.add(user.id!);
                            return true;
                        }),
                );
            })
            .catch((err) => {
                console.error(err);
                enqueueSnackbar(
                    'Une erreur est survenue lors de la récupération des utilisateurs de vos groupes',
                    { variant: 'error' },
                );
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userGroups]);

    return usersInGroups;
};

export default useUsersInGroups;
